<!-- 模板 -->
<template>
  <footer>
    <div class="footer-bottom">
      <div class="wrap">
        <p>
          Copyright © Institute of Physics Chinese Academy of Sciences, Advanced
          Materials & Electron Microscopy (A01) P.O.Box 603,<br />Beijing
          100190,China　Tel: 010-82649359　E-mail: gemengshu@iphy.ac.cn
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >京ICP备1111111号-1</a
          >&nbsp;&nbsp;&nbsp;&nbsp;后台：<a
            href="http://ceshi.demo.kwsem.com:88/qdC/hjc/erwei-admin/#/"
            target="_blank"
            >webManager</a
          >
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
// import request from '../utils/request.js'
export default {
  name: "Footer",
  data() {
    return {
      links: [
        { text: "Main", path: "/" },
        { text: "About us", path: "/about" },
        { text: "Upload", path: "/upload" },
        { text: "Feedback", path: "/feedback" },
      ],
    };
  },
  props: [],
  components: {},
  computed: {},
  filters: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less">
// @import url(); 引入公共css类
footer {
  width: 100%;

  background-color: #e5e5e5;
  .footer-top {
    height: 120px;
    background-color: #fff;
    .wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      h3 {
        font-size: 18px;
        margin-bottom: 0.5rem;
      }
      p {
        font-size: 14px;
        color: #666;
      }
    }
  }
  .footer-bottom {
    height: 80px;
    .wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      height: 100%;
      p {
        font-size: 14px;
        text-align: center;
        a {
          font-size: 14px;
          &:hover {
            color: #00a0e9;
          }
        }
      }
    }
  }
}
</style>
